import { useAppSelector } from '@/hooks/useAppSelector';

import { selectCreatedBy } from '../services/selectors';
import type { Secret } from '../types';

export const useCreatedBy = (id: Secret['id']) => useAppSelector(state => selectCreatedBy(state, { id }));
